const $ = jQuery;

const app = {
	$offCanvasOpen: $('#off-canvas-open'),
	$offCanvas: $('#off-canvas'),

	init() {
		this.historyBack();
		this.filterDownloads();
		this.mainMenu();
		this.toggleView();
		this.powerVisualization();
		this.cardInfoList();
        if( $('.scroll-down-button').length >= 1 ) {
            this.hideScrollDown();
        }
		if ($('#multiple-images').length > 0) {
			this.images();
		}
	},

	historyBack() {
		$('.history-back').on('click', () => {
			window.history.go(-1);
		});
	},

	mainMenu() {
		this.$offCanvas.width(this.getOffCanvasWidth());

		this.$offCanvasOpen.on('click', function (e) {
			e.preventDefault();
			$(this).toggleClass('active');
		});

		if ($('#has-header-bg').length) {
			this.$offCanvasOpen.addClass('has-bg-img');
		}

		let resizeTimer;
		$(window).on('resize', function (e) {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function () {
				app.$offCanvas.width(app.getOffCanvasWidth());
			}, 250);
		});
	},

	getOffCanvasWidth() {
		let $offCanvasWidth = $(window).width() - this.$offCanvasOpen.offset().left + 72;
		$offCanvasWidth = $offCanvasWidth < 375 ? 375 : $offCanvasWidth;
		return $offCanvasWidth;
	},

	downloadIconAnimation() {
		$('.download-file-link').hover(
			function () {
				let $this = $(this),
					$bottomBar = $this.find('#download-icon .bottombar'),
					$arrowBody = $this.find('#download-icon .arrow-body'),
					$arrow = $this.find('#download-icon .arrow');

				$bottomBar.attr('d', 'M1,24 C6.33333333,26.6666667 11.6666667,26.6666667 17,24');

				$arrowBody.attr('y', 2);

				$arrow.attr(
					'transform',
					'translate(9.000000, 19.000000) rotate(-270.000000) translate(-9.000000, -17.000000)'
				);
			},
			function () {
				let $this = $(this),
					$bottomBar = $this.find('#download-icon .bottombar'),
					$arrowBody = $this.find('#download-icon .arrow-body'),
					$arrow = $this.find('#download-icon .arrow');

				$this.find('#download-icon .bottombar').attr('d', 'M1,24 L1,24 17,24');

				$this.find('#download-icon .arrow-body').attr('y', 0);

				$this
					.find('#download-icon .arrow')
					.attr(
						'transform',
						'translate(9.000000, 17.000000) rotate(-270.000000) translate(-9.000000, -17.000000)'
					);
			}
		);
	},

	filterDownloads() {
		const $filter = $('#downloads-year-dropdown'),
			$downloads = $('.downloads > li');

		let str = '<li><a href="#all" rel="nofollow">All</a></li>',
			date,
			date_arr = [];

		const unique = (value, index, self) => {
			return self.indexOf(value) === index;
		};

		$downloads.each(function () {
			date = $(this).data('date');
			date_arr.push(date);
		});
		const unique_dates1 = new Set(date_arr);
		const unique_dates = [...unique_dates1];

		unique_dates.forEach(
			(element) => (str += '<li><a href="#' + element + '" rel="nofollow">' + element + '</a></li>')
		);
		$filter.html(str);

		$filter.find('a').on('click', function (e) {
			e.preventDefault();
			let current_filter = $(this).attr('href');
			current_filter = current_filter.substring(1);

			if (current_filter === 'all') {
				$downloads.fadeIn(300);
				$('#current-year').text('Year');
			} else {
				$('#current-year').text(current_filter);
				$downloads.hide();
				var $show_items = $('.downloads > li[data-date="' + current_filter + '"]');
				$show_items.fadeIn(300);
			}
		});
	},

	animateValue() {
		$('.aos-animate')
			.find('.countme')
			.each(function () {
				$(this)
					.prop('Counter', 0)
					.animate(
						{
							Counter: $(this).data('countto'),
						},
						{
							duration: 2000,
							easing: 'swing',
							step: function (now) {
								// Formats number to use Canadian number formatting which adds a comma between each thousand
								let spaced = new Intl.NumberFormat('cny-IN', { maximumSignificantDigits: 12 }).format(
									now
								);
								// Replaces all the decimals with nothing
								spaced = spaced.replace(/[.][0-9]+/gi, '');
								// Spits outs the formatted number
								$(this).text(spaced);
							},
						}
					);
			});
	},

	scrollDown(sectionCount) {
        // Define which section to scroll to with parameter
		$([document.documentElement, document.body]).animate(
			{
				scrollTop: $('section:nth-of-type(' + sectionCount + ')').offset().top,
			},
			500
		);
	},

	hideScrollDown() {
        // Only hide it if there are more than 2 sections
		if ( $('.section').length >= 2 ) {

            // They are display none in CSS but they also has to be hidden here
			if( $(window).width() > 700 ) {
                let thirdSectionPos;

                // On front page it scrolls to 2 section else to 3 section
                if( $('.home').length == 1 ) {
                    thirdSectionPos = $('.section:nth-of-type(2)').offset().top;
                } else if( $('.home').length == 0 ) {
                    thirdSectionPos = $('.section:nth-of-type(3)').offset().top;
                }

                // Hide or show on scroll
                $(document).on('scroll', function () {
                    if (window.scrollY >= (thirdSectionPos - 50) ) {
                        $('.scroll-down-button').fadeOut(100);
                    }
                    if (window.scrollY <= (thirdSectionPos - 50) ) {
                        $('.scroll-down-button').fadeIn(100);
                    }
                });
			}
		}
	},

	scrollUp() {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	},

	images() {
		let counterID = 0;
		counterID++;

		$('#multiple-images').attr('src', imagesArray[0]);

		setInterval(() => {
			if (counterID >= imagesArray.length) {
				counterID = 0;
				setTimeout(() => {
					$('#multiple-images').attr('src', imagesArray[counterID]);
					setTimeout(() => {
						counterID++;
					});
				}, 300);
			} else {
				setTimeout(() => {
					$('#multiple-images').attr('src', imagesArray[counterID]);
					setTimeout(() => {
						counterID++;
					});
				}, 300);
			}
		}, 4000);
	},

	adjustFlipHeight(element) {
		height = element.innerHeight();
		$('.flip').height(height);
	},

	toggleView() {
		this.adjustFlipHeight($('.toggleable:visible'));
		let _this = this;
		$('.toggle-view').on('click', function (e) {
			e.preventDefault();

			if ($(this).attr('data-toggle') == 'map-view') {
				$('.stations .section-title').text('Plant Locations');
			} else if ($(this).attr('data-toggle') == 'list-view') {
				$('.stations .section-title').text('Plant Details');
			}

			// Flip back to map
			gmap.markerClicked = false;

			$('.flip').removeClass('flip--active');
			if (!$(this).hasClass('active')) {
				let toggle = $(this).attr('data-toggle'),
					section = $(this).closest('section');

				// Remove all of the views
				section.find('.toggle-view').removeClass('active');
				section.find('.toggleable').fadeOut(200);

				// Show the clicked view
				$(this).addClass('active');
				setTimeout(function () {
					let visibile_view = section.find(`.toggleable[data-view="${toggle}"]`);
					visibile_view.fadeIn();
					_this.adjustFlipHeight(visibile_view);
				}, 190);
			}
		});
	},

	powerVisualization() {
		let is_paused = false;

		// When hovering over an item all the others fade out but the one hovered stays visible
		$('.vis-item').on('mouseenter', function (e) {
			$('.vis-number, .vis-text').css('opacity', '0');
			$(this).closest('.vis-item').children()[1].style.opacity = 1;
			$(this).closest('.vis-item').children()[2].style.opacity = 1;
			is_paused = true;
		});

		$('.vis-item').on('mouseleave', function (e) {
			is_paused = false;
		});

		let counterID = 0;
		let count = $('.vis-item').length;

		$('.vis-number, .vis-text').css('opacity', '0');
		$('.id-' + counterID).css('opacity', '1');

		// is_paused is changed on hover
		setInterval(function () {
			if (is_paused) {
				// Do nothing
			} else {
				$('.vis-number, .vis-text').css('opacity', '0');
				counterID++;
				$('.id-' + counterID).css('opacity', '1');
				if (counterID == count - 1) {
					counterID = -1;
				}
			}
		}, 3000);
	},

	cardInfoList() {
		$('.station-item a').on('click', function (e) {
			e.preventDefault();

			let clicked_id = $(this).attr('id'),
				location = stationInfo.filter((obj) => {
					return obj.id == clicked_id;
				});

			gmap.flipToShowInfo(location[0]);
		});
	},
};

app.init();

$(document).ready(function ($) {
	AOS.init({
		easing: 'easeOutShine',
		duration: 600,
		offset: 40,
	});
});

document.addEventListener('aos:in:in-view', ({ detail }) => {
	app.animateValue();
});
